import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: "ds-order-system-status-info",
  templateUrl: "./order-system-status-info.component.html",
  styleUrls: ["./order-system-status-info.component.scss"],
})
export class OrderSystemStatusInfo implements OnInit {
  constructor() {}

  @Input() pickupHeading!: string;
  @Input() pickupDate!: string;
  @Input() statusInfoHeader: string = "";
  @Input() statusInfoText: string = "";

  ngOnInit(): void {}
}
